import React, { useState, useEffect, useRef, ReactNode } from 'react';

interface PostMessageOnResizeWrapperProps {
  children: ReactNode;
}

const PostMessageOnResizeWrapper: React.FC<PostMessageOnResizeWrapperProps> = ({
  children,
}) => {
  const [height, setHeight] = useState<number>();
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!containerRef.current) {
      return;
    }

    const resizeObserver = new ResizeObserver(() => {
      if (
        containerRef.current &&
        containerRef.current.offsetHeight !== height
      ) {
        const newHeight = containerRef.current.offsetHeight;
        setHeight(newHeight);
        const message = { type: 'resize', height: newHeight };

        window.parent.postMessage(message, '*');
      }
    });

    resizeObserver.observe(containerRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [height]);

  return <div ref={containerRef}>{children}</div>;
};

export default PostMessageOnResizeWrapper;
